<footer
  class="footer-credential d-flex align-items-center py-3"
  [style.background]="footerBackground"
>
  <div class="container">
    <div class="footer-block footer-block-left">
      <span class="footer-text d-flex align-items-center justify-content-center gap-2 flex-wrap" [style.color]="footerTextColor">
        <a [href]="landingUrl" target="_blank">
          <img
            src="assets/img/logo-white.png"
            height="12"
            alt="ShareWave"
            (error)="onErrorImage()"
            class="footer-logo"
          />
        </a>
        <span>© 2022-{{ year }} Content Media</span>
      </span>
    </div>
    <div class="footer-block footer-block-right">
      <a [style.color]="footerTextColor" href="mailto:{{ email }}" class="footer-email-link">
        <span class="footer-text" [style.color]="footerTextColor">
          {{ email }}
        </span>
      </a>
    </div>
  </div>
</footer>

